<template>
    <section class="container-fluid">
        <div class="row mcas">
            <div class="col-md-6 col-lg-4 main">
               
                <div class="row" id="odrea"></div>
                <div class="row" id="opffp"></div>
                <div class="row" id="anof"></div>
                <div class="row" id="dta_ref">
                    <div class="col-12 m-record">
                        <div class="row nav-top">
                            <div class="col-2 xtl"><span class="nav-back wt"  onclick="window.location.href='#/'"></span></div>
                            <div class="col-8 tfw-5 tf-18">Rewards</div>
                            <div class="col-2"></div>
                        </div>
                        <div class="row mt-1 mb-4 plr-15 pb-4" id="rwdss">
                            <!-- <div class="col-12 mt-2 pt-4 pb-2 mxui">
                                <div class="row">
                                    <div class="col-8 xtl tf-16 tfw-6">Welcome</div>
                                    <div class="col-4 xtr tf-18 tfw-7">20</div>
                                    <div class="col-12">
                                        <div class="pback"><span class="pgbx p100"></span></div>
                                    </div>
                                    <div class="col-12">We will reward you with 20 when you join our Telegram Channel.
                                    </div>
                                    <div class="col-12 xtc mt-2 pb-2">
                                        <div class="cinBtn" id="wbc">Claimed</div>
                                    </div>
                                </div>
                            </div> -->
                            <div class="col-12 mt-2 pt-4 pb-2 mxui">
                                <div class="row">
                                    <div class="col-8 xtl tf-16 tfw-6">Sign up</div>
                                    <div class="col-4 xtr tf-18 tfw-7">20</div>
                                    <div class="col-12">
                                        <div class="pback"><span id="frpb" class="pgbx" style="width: 100%;"></span>
                                        </div>
                                    </div>
                                    <div class="col-12">This reward is added directly after sign up.
                                    </div>
                                    <div class="col-12 xtc mt-2 pb-2">
                                        <div class="cinBtn" id="frbo">Claimed</div>
                                    </div>
                                </div>
                            </div>
                          
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>